module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/30ft-c46affb2b4014bc8db8d300aea682b9d.png";